<template>
  <bottom-bar-layout class="page-receive-vip"
                     :show-bar="render.bottomBar.show"
                     bar-background="transparent"
                     :bar-height="140"
                     :show-consult="false"
                     :shadow="false"
  >
    <vip-user-info v-if="invite.giver"
                   class="page-receive-vip-giver-info"
                   :avatar="invite.giver.avatar"
                   :name="invite.giver.name"
                   :type="invite.giver.vipType"
    >
      {{ invite.hint }}
    </vip-user-info>
    <div class="page-receive-vip-content">
      <ym-img class="img-1"
              :src="require('@/assets/img/vip/experience/1.png')"
      />
      <ym-img class="img-2"
              :src="require('@/assets/img/vip/experience/2.png')"
      />
      <ym-img class="img-3"
              :src="require('@/assets/img/vip/experience/3.png')"
      />
      <swiper class="page-receive-vip-course-swiper-list"
              :options="swiperOption"
      >
        <swiper-slide class="page-receive-vip-course-swiper-slide"
                      v-for="(item, index) in list"
                      :key="index"
        >
          <img class="img-4"
               :src="item"
          />
        </swiper-slide>
      </swiper>
      <ym-img class="img-5"
              :src="require('@/assets/img/vip/experience/5.png')"
      />
      <ym-img class="img-6"
              :src="require('@/assets/img/vip/experience/6.png')"
      />
      <ym-img class="img-7"
              :src="require('@/assets/img/vip/experience/7.png')"
      />
    </div>
    <template #tabbar>
      <div class="page-receive-vip-bottom-bar"
           @click="handleClickReceive"
      >
        <ym-button class="page-receive-vip-btn"
                   type="gradient-highlight"
                   size="large"
                   round
        >
          {{ render.bottomBar.text }}
        </ym-button>
      </div>
    </template>
  </bottom-bar-layout>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import { Button } from '@ymba/ym-ui';
  import VipUserInfo from '@/pages/MyVip/components/VipUserInfo';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import { getReceiveExperienceVipDetail, receiveExperienceVip } from '@/services/vip';
  import { locationHref } from '@/utils';

  export default {
    name: 'PageReceiveExperienceVip',
    metaInfo: {},
    components: {
      BottomBarLayout,
      'ym-button': Button,
      swiper,
      swiperSlide,
      VipUserInfo,
    },
    data() {
      return {
        swiperOption: {
          loop: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          loopedSlides: 3,
          spaceBetween: 15,
          autoplay: {
            delay: 3000,
          },
        },
        list: [
          // eslint-disable-next-line global-require
          require('@/assets/img/vip/experience/4_1.png'),
          // eslint-disable-next-line global-require
          require('@/assets/img/vip/experience/4_2.png'),
          // eslint-disable-next-line global-require
          require('@/assets/img/vip/experience/4_3.png'),
        ],
        invite: {
          giver: null,
          hint: '',
        },
        vip: {
          id: 0,
          headerCover: '',
          about: '',
        },
        render: {
          pageTitle: '',
          freeDayCount: 0,
          bottomBar: {
            show: false,
            text: '',
            action: '',
            url: '',
          },
          alertMessage: null,
        },
      };
    },
    computed: {
      primaryPrice() {
        return {
          current: {
            name: `${this.render.freeDayCount}天限时体验`,
            value: 0,
          },
          origin: {
            value: 999,
          },
        };
      },
    },
    methods: {
      handleAlertMessage(alertMessage) {
        const {
          title, message, cancel, confirm,
        } = alertMessage;
        this.$dialog.confirm({
          title,
          message,
          cancelButtonText: cancel.buttonText,
          confirmButtonText: confirm.buttonText,
          closeOnClickOverlay: true,
        }).then(() => {
          this.$router.push(confirm.url);
        }).catch(() => {
          this.$router.push(cancel.url);
        });
      },
      async fetchData(id) {
        const query = this.$route.query || {};
        const params = Object.assign({ id }, query);
        const data = await getReceiveExperienceVipDetail(params);

        this.invite = data.invite;
        this.vip = data.vip;
        this.render = data.render;
      },
      async handleClickReceive() {
        const { render } = this;
        const { bottomBar } = render;
        const { action, url } = bottomBar;
        if (action === 'share' || action === 'redirect') {
          locationHref(url);
          return;
        }
        const { vip: { id } } = this;
        const query = this.$route.query || {};
        const params = Object.assign({ id }, query);
        const data = await receiveExperienceVip(params);
        const { render: { alertMessage } = {} } = data;
        if (alertMessage) {
          this.handleAlertMessage(alertMessage);
          return;
        }
        const { sn } = data;
        const route = { name: 'PayNotify', params: { sn } };
        this.$router.push(route);
      },
    },
    created() {
      const { $route: { params: { id } } } = this;
      this.fetchData(id);
    },
    beforeRouteUpdate(to, from, next) {
      const { params: { id } } = to;
      this.fetchData(id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-receive-vip {
    background: linear-gradient(to right, #212c4a, #121b33);

    &-giver-info {
      box-sizing: border-box;
      padding: @size-small 0 @size-small @size-extra-medium;
      background: #feecd7;
      /deep/ .vip-user-info-slot {
        color: @color-text-light;
        font-size: @font-size-base;
      }
    }

    &-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    &-course-swiper-list {
      width: 100%;
    }

    &-course-swiper-slide {
      width: 560px;
    }

    .img-2 {
      margin: @size-medium auto 94px;
    }
    .img-3 {
      width: 536px;
      height: 212px;
      margin: 0 auto 36px;
    }
    .img-4 {
      display: block;
      width: 560px;
      height: 700px;
    }
    .img-5 {
      width: 434px;
      height: 76px;
      margin: @size-small auto 86px;
    }
    .img-6 {
      margin-bottom: 74px;
    }

    &-bottom-bar {
      box-sizing: border-box;
      flex: 1;
      align-self: stretch;
      padding: @size-small @size-base;
    }

    &-btn {
      background: linear-gradient(360deg,
      #f44049 0%,
      #ff6f72 100%);
    }
  }
</style>
